import { errors } from 'redux-rest-reducer';
import uuid from 'uuid/v1';

import { ACTIONS as logoutActions } from '@~/actions/logout';
import { ACTIONS } from '@~/actions/student-events';

const initialState = [];

function getEventsMap(events) {
  const eventsMap = {};

  events.forEach(event => {
    eventsMap[event.id] = event;
  });

  return eventsMap;
}

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.PUSH_STUDENT_EVENT:
      return [
        ...state,
        {
          id: uuid(),
          event: payload.event,
        },
      ];
    case ACTIONS.PUSH_STUDENT_EVENTS:
      return [
        ...state,
        ...payload.events.map(event => ({
          id: uuid(),
          event,
        })),
      ];
    case ACTIONS.CLEAR_STUDENT_EVENTS: {
      const eventsMap = getEventsMap(payload.events);

      return state.filter(({ id }) => !eventsMap[id]);
    }
    case logoutActions.POST_SUCCESS:
    case errors[401]:
      return initialState;
    default:
      return state;
  }
}
